import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";  
import Loader from '@iso/components/utility/loader';
// lazy import print komponente
const PrintIzvjestaj = lazy(() =>
  import("@iso/containers/Izvjestaji/print-izvjestaj")
);
const PrintRacuna = lazy(() =>
  import("@iso/containers/Prodaja/Racuni/PregledRacuna/print-racuna")
);
const PrintKnjigaRacuna = lazy(() =>
  import("@iso/containers/Prodaja/Racuni/PregledRacuna/print-knjiga-racuna")
);
const PrintCjenika = lazy(() =>
  import("@iso/containers/Cjenici/PregledCjenika/print-cjenika")
);
const PrintPrimke = lazy(() =>
  import("@iso/containers/RobnoMaterijalno/Primke/print-primke")
);
const PrintOtpremnice = lazy(() =>
  import("@iso/containers/RobnoMaterijalno/Otpremnice/print-otpremnice")
);
const PrintMskl = lazy(() =>
  import("@iso/containers/RobnoMaterijalno/Medjuskladisnice/print-mskl")
);
const PrintStanjeSkl = lazy(() =>
  import("@iso/containers/RobnoMaterijalno/StanjeSkladista/print-stanje-skl")
);
const PrintNormativa = lazy(() =>
  import("@iso/containers/RobnoMaterijalno/Normativi/print-normativa")
);
export default function PrintRoutes() {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        {/* print ruta VAN dashboard layouta */}
        <Route exact path="/print-izvjestaj" component={PrintIzvjestaj} />
        <Route exact path="/print-racuna" component={PrintRacuna} />
        <Route exact path="/print-knjiga-racuna" component={PrintKnjigaRacuna} />
        <Route exact path="/print-cjenika" component={PrintCjenika} />
        <Route exact path="/print-primke" component={PrintPrimke} />
        <Route exact path="/print-otpremnice" component={PrintOtpremnice} />
        <Route exact path="/print-mskl" component={PrintMskl} />
        <Route exact path="/print-stanje-skl" component={PrintStanjeSkl} />
        <Route exact path="/print-normativa" component={PrintNormativa} />
      </Switch>
    </Suspense>
  );
}